import { useFragmentFromStore } from '@smx-ui-model/hooks/use-fragment-from-store';
import { useEffect, useState } from 'react';

import { drawingSetFragment$key } from '../graphql/__generated__/drawingSetFragment.graphql';
import { JobStatus } from '../graphql/__generated__/drawingSetJobFragment.graphql';
import { DrawingSetUploadProcess } from './drawing-set-upload-process';
import { SuspenseWrapper } from './suspense-wrapper';

interface IndicatorStatusDrawingSetProps {
    node: any;
    setJobIndicatorStatus: React.Dispatch<React.SetStateAction<JobStatus | undefined>>;
}

export const IndicatorStatusDrawingSet = ({ node, setJobIndicatorStatus }: IndicatorStatusDrawingSetProps) => {
    const [jobStatus, setJobStatus] = useState<JobStatus>();
    const dataNode = useFragmentFromStore<drawingSetFragment$key>(node);

    useEffect(() => {
        setJobIndicatorStatus(jobStatus);
    }, [jobStatus]);

    return (
        <SuspenseWrapper>
            <DrawingSetUploadProcess
                jobId={dataNode.currentJobId! || dataNode.previousJobId!}
                setJobStatus={setJobStatus}
                modeView={'small'}
                timeout={5000}
            />
        </SuspenseWrapper>
    );
};
